import {L10nConfig, L10nLoader} from 'angular-l10n';
import {i18nAsset} from '../assets/l18n/l18n';

export const l10config: L10nConfig = {
    format: 'language-region',
    keySeparator: '.',
    providers: [
        {
            name: 'app',
            asset: i18nAsset
        }
    ],
    defaultLocale: {
        language: 'de-DE',
    },
    schema: [
        {
            locale: {
                language: 'de-DE',
                numberLanguage: 'de-DE'
            },
            dir: 'ltr',
            text: 'de'
        },
        {
            locale: {
                language: 'en-EN',
                numberLanguage: 'en-EN'
            },
            dir: 'ltr',
            text: 'en'
        },
        {
            locale: {
                language: 'fr-FR',
                numberLanguage: 'fr-FR'
            },
            dir: 'ltr',
            text: 'fr'
        },
        {
            locale: {
                language: 'it-IT',
                numberLanguage: 'it-IT'
            },
            dir: 'ltr',
            text: 'it'
        },
    ]
};

export function initL10n(l10nLoader: L10nLoader): () => Promise<void> {
    return () => l10nLoader.init();
}
